export const CONSENT_COOKIE_NAME = "t_consent";
export const CONSENT_DURATION_SECONDS = 365 * 24 * 60 * 60;

export type ConsentValue = "all" | "necessary";

// The optional suffix tracks account synchronization, not a different permission.
export const CONSENT_VALUE_PATTERN = /^(all|necessary)(?:\.v2\.(pending|saved))?$/;

export function readConsentChoice(raw: unknown): ConsentValue | undefined {
  if (typeof raw !== "string") return;
  const choice = CONSENT_VALUE_PATTERN.exec(raw)?.[1];
  return choice === "all" || choice === "necessary" ? choice : undefined;
}
